var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgINotificationSupernova = function SvgINotificationSupernova(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_6181_11725)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6181_11725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1125 7.35599L11.9132 7.0235L10.9296 4.9502C10.5499 4.14957 9.45132 4.14927 9.0714 4.95017L8.08781 7.0235L5.88848 7.35599C5.03923 7.48434 4.69956 8.57111 5.31428 9.19455L6.90573 10.8084L6.53005 13.0872C6.38497 13.9671 7.2734 14.6391 8.03338 14.2235L10.0005 13.1476L11.9677 14.2235C12.7285 14.6396 13.6157 13.9651 13.4709 13.0872L13.0952 10.8084L14.6867 9.19455C15.3012 8.57133 14.9621 7.48442 14.1125 7.35599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8912 5.69814L6.35967 4.93052C6.21537 4.72219 5.93743 4.67598 5.73888 4.82739C5.54032 4.97877 5.49631 5.27041 5.64058 5.47877L6.17211 6.24639C6.31649 6.45482 6.59446 6.50087 6.7929 6.34951C6.99146 6.19816 7.03547 5.90649 6.8912 5.69814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53519 11.402C5.46362 11.1812 5.22712 11.0602 5.00683 11.1321L4.17899 11.4018C3.95876 11.4736 3.83825 11.7108 3.90979 11.9317C3.98148 12.153 4.21847 12.2734 4.43814 12.2017L5.26601 11.9319C5.48624 11.8602 5.60675 11.6229 5.53519 11.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2617 4.8274C14.0631 4.67599 13.7852 4.72217 13.6409 4.93052L13.1093 5.69814C12.965 5.9065 13.0091 6.19817 13.2076 6.34952C13.4063 6.50096 13.6842 6.45467 13.8284 6.24639L14.36 5.47878C14.5043 5.27042 14.4602 4.97878 14.2617 4.8274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8217 11.4019L14.9938 11.1321C14.7736 11.0602 14.537 11.1812 14.4655 11.4021C14.3939 11.6229 14.5144 11.8602 14.7347 11.932L15.5625 12.2017C15.7823 12.2734 16.0192 12.1529 16.0909 11.9318C16.1624 11.7109 16.0419 11.4736 15.8217 11.4019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.7871C9.75465 14.7871 9.55566 14.9959 9.55566 15.2534V16.1999C9.55566 16.4575 9.75465 16.6663 10.0001 16.6663C10.2455 16.6663 10.4445 16.4575 10.4445 16.1999V15.2534C10.4445 14.9959 10.2456 14.7871 10.0001 14.7871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6181_11725",
    x1: 16.25,
    y1: 2.5,
    x2: 3.75,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#AAB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84FFC9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6181_11725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(3.3335 3.33398)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgINotificationSupernova);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-notification-supernova.bab621496c981bc1a7afb1ff60c3c638.svg";